import { User } from '@DStypes/User';
import LocalStorage from './storage';

const ACCESS_TOKEN = 'access';
const REFRESH_TOKEN = 'refresh';
const USER_INFO = 'user';
const SQUIRREL_BOT_STATUS = 'squirrel_bot_status';
const USER_DETAILS = 'user_details';
const IS_USER_SIGNED_IN = 'is_user_signed_in';
const VISITED_CHARTS = 'visted_charts';

interface UserToken {
  access: string;
  refresh: string;
}

class UserAuth {
  static clearTokens(): void {
    LocalStorage.remove(ACCESS_TOKEN);
    LocalStorage.remove(REFRESH_TOKEN);
    LocalStorage.remove(USER_INFO);
    LocalStorage.remove(SQUIRREL_BOT_STATUS);
    LocalStorage.remove(VISITED_CHARTS);
    LocalStorage.remove(USER_DETAILS);
  }

  static setTokens(token: UserToken): void {
    LocalStorage.setItem(ACCESS_TOKEN, token.access);
    LocalStorage.setItem(REFRESH_TOKEN, token.refresh);
  }

  static setAccessToken(access: string): void {
    LocalStorage.setItem(ACCESS_TOKEN, access);
  }
  static setUserInfo(user: User): void {
    LocalStorage.setItem(USER_INFO, JSON.stringify(user));
  }

  static get refreshToken(): string | null {
    return LocalStorage.getItem(REFRESH_TOKEN);
  }

  static get accessToken(): string | null {
    return LocalStorage.getItem(ACCESS_TOKEN);
  }

  static get userInfo(): User | null {
    if (LocalStorage.getItem(USER_INFO) !== null)
      return JSON.parse(LocalStorage.getItem(USER_INFO) as string) as User;

    return null;
  }

  static get squirrelBotStatus(): string | null {
    if (LocalStorage.getItem(SQUIRREL_BOT_STATUS) !== null)
      return JSON.parse(LocalStorage.getItem(SQUIRREL_BOT_STATUS) as string);

    return null;
  }

  static setOpenedSquirrelBot(status: string): void {
    return LocalStorage.setItem(SQUIRREL_BOT_STATUS, JSON.stringify(status));
  }

  static setUserDetails(userDetails: any): void {
    return LocalStorage.setItem(USER_DETAILS, JSON.stringify(userDetails));
  }

  static get userDetails(): any {
    if (LocalStorage.getItem(USER_DETAILS) !== null)
      return JSON.parse(LocalStorage.getItem(USER_DETAILS) as string);

    return null;
  }

  static setIsUserSignedIn(sign_in_channel: string): void {
    return LocalStorage.setItem(
      IS_USER_SIGNED_IN,
      JSON.stringify(sign_in_channel)
    );
  }

  static get isUserSignedIn(): any {
    return JSON.parse(LocalStorage.getItem(IS_USER_SIGNED_IN) as string);
  }

  static removeIsUserSignedIn(): void {
    return LocalStorage.remove(IS_USER_SIGNED_IN);
  }

  static get isAuthenticated(): boolean {
    return Boolean(UserAuth.accessToken);
  }

  static setVisitedCharts(charts: any): void {
    return LocalStorage.setItem(VISITED_CHARTS, JSON.stringify(charts));
  }

  static get visitedCharts(): any {
    if (LocalStorage.getItem(VISITED_CHARTS) !== null)
      return JSON.parse(LocalStorage.getItem(VISITED_CHARTS) as string);

    return null;
  }
}

export default UserAuth;
